import { render, staticRenderFns } from "./DarkToggler.vue?vue&type=template&id=b5e05840"
import script from "./DarkToggler.vue?vue&type=script&lang=js"
export * from "./DarkToggler.vue?vue&type=script&lang=js"
import style0 from "./DarkToggler.vue?vue&type=style&index=0&id=b5e05840&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports